import { graphql } from '../../types/swarmx/gql'

export const TokenQuery = graphql(`
  query Token($id: ID!) {
    asset(id: $id) {
      id
      name
      symbol
      address
      decimals
      tokenId
      assetType
      kya
      tokenStandard
      tradedVolume
    }
  }
`)
